import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {interval, Observable} from 'rxjs';
import { Config } from '@vendor/config/config';
import {SwUpdate} from "@angular/service-worker";
@Injectable({
  providedIn: 'root'
})
export class UpdateService {
  constructor(private config: Config,
              private http: HttpClient,
              public updates: SwUpdate) {
    if (updates.isEnabled) {
      interval(60 * 1000).subscribe(() => updates.checkForUpdate()
        // .then(() => console.log('checking for updates'))
      );
    }
  }
  public checkForUpdates(): void {
    this.updates.available.subscribe(event => this.promptUser());
  }

  private promptUser(): void {
    // console.log('updating to new version');
    this.updates.activateUpdate().then(() => document.location.reload());
  }
}
